import { Bounds, Environment, Float, OrbitControls, RoundedBox, useGLTF, useMask } from '@react-three/drei';
import { Canvas, MeshProps } from '@react-three/fiber';
import * as React from 'react';
import { DirectionalLight } from 'three/src/lights/DirectionalLight';
import Area from './Area';
import glbReactTransformed from './react-transformed.glb';

function Box(props: React.ComponentProps<typeof RoundedBox> & { color: string }) {
  const { color, ...rest } = props;
  return (
    <RoundedBox {...rest}>
      <meshPhongMaterial color={color} />
    </RoundedBox>
  );
}

function Atom(props: MeshProps) {
  // const stencil = useMask(1, );
  const { nodes } = useGLTF(glbReactTransformed) as any;
  return (
    <mesh castShadow receiveShadow geometry={nodes.atom.geometry} {...props} dispose={null}>
      <meshPhongMaterial color="#33BBFF" />
    </mesh>
  );
}

export type Props = {};

function App03(props: Props) {
  const {} = props;
  const refLight = React.useRef<DirectionalLight>(null);
  // const [count, setCount] = React.useState(0);
  // React.useEffect(() => {
  //   setCount((prev) => prev + 1);
  // }, []);
  console.log('App01', { refLight });
  return (
    <Area>
      <Canvas camera={{ position: [0, 3, 10], fov: 50 }}>
        <directionalLight position={[1, 2, 1.5]} intensity={0.5} castShadow />
        <hemisphereLight intensity={1.5} groundColor="red" />
        <Float floatIntensity={4} rotationIntensity={0} speed={4}>
          <Atom scale={1.5} />
        </Float>

        <Box color="#EAC435" args={[1, 5, 1]} rotation-y={Math.PI / 4} position={[0, 0, -2]} />
        <Box color="#03CEA4" args={[2, 2, 2]} position={[-2, 0, -2]} />
        <Box color="#FB4D3D" args={[2, 2, 2]} position={[2, 0, -2]} />
        <OrbitControls makeDefault />
        <axesHelper />
        <gridHelper />
      </Canvas>
    </Area>
  );
}

export default React.memo(App03);
